<template>
    <Head title="My Wallet" />
    <div class="px-4 md:px-8">
        <Wallet />
    </div>
</template>

<script setup>
import { Head } from '@inertiajs/vue3';
import Wallet from '@/components/wallet/index.vue';
</script>
